import { Trigger } from './events';
import crypto from 'crypto';
export var sha256Hash = function sha256Hash(str) {
  return crypto.createHash('sha256').update(str).digest('hex');
};
export var getTrigger = function getTrigger(e) {
  if (e instanceof KeyboardEvent) {
    return Trigger.RETURN;
  }
  return e.screenX === 0 ? Trigger.RETURN : Trigger.CLICK;
};
export var isNewTab = function isNewTab(e) {
  return !!(e && (e.metaKey || e.ctrlKey || e.shiftKey));
};
export var getWordCount = function getWordCount(str) {
  return str.length > 0 ? str.split(/\s+/).length : 0;
};